"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Tile = _interopRequireDefault(require("./Tile.js"));

var _dom = require("./dom.js");

var _util = require("./util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/VectorRenderTile
 */


/**
 * @typedef {Object} ReplayState
 * @property {boolean} dirty Dirty.
 * @property {null|import("./render.js").OrderFunction} renderedRenderOrder RenderedRenderOrder.
 * @property {number} renderedTileRevision RenderedTileRevision.
 * @property {number} renderedResolution RenderedResolution.
 * @property {number} renderedRevision RenderedRevision.
 * @property {number} renderedTileResolution RenderedTileResolution.
 * @property {number} renderedTileZ RenderedTileZ.
 */

/**
 * @type {Array<HTMLCanvasElement>}
 */
var canvasPool = [];

var VectorRenderTile =
/** @class */
function (_super) {
  __extends(VectorRenderTile, _super);
  /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {import("./tilecoord.js").TileCoord} urlTileCoord Wrapped tile coordinate for source urls.
   * @param {function(VectorRenderTile):Array<import("./VectorTile").default>} getSourceTiles Function
   * to get source tiles for this tile.
   */


  function VectorRenderTile(tileCoord, state, urlTileCoord, getSourceTiles) {
    var _this = _super.call(this, tileCoord, state, {
      transition: 0
    }) || this;
    /**
     * @private
     * @type {!Object<string, CanvasRenderingContext2D>}
     */


    _this.context_ = {};
    /**
     * Executor groups by layer uid. Entries are read/written by the renderer.
     * @type {Object<string, Array<import("./render/canvas/ExecutorGroup.js").default>>}
     */

    _this.executorGroups = {};
    /**
     * Executor groups for decluttering, by layer uid. Entries are read/written by the renderer.
     * @type {Object<string, Array<import("./render/canvas/ExecutorGroup.js").default>>}
     */

    _this.declutterExecutorGroups = {};
    /**
     * Number of loading source tiles. Read/written by the source.
     * @type {number}
     */

    _this.loadingSourceTiles = 0;
    /**
     * @type {Object<number, ImageData>}
     */

    _this.hitDetectionImageData = {};
    /**
     * @private
     * @type {!Object<string, ReplayState>}
     */

    _this.replayState_ = {};
    /**
     * @type {Array<import("./VectorTile.js").default>}
     */

    _this.sourceTiles = [];
    /**
     * @type {Object<string, boolean>}
     */

    _this.errorTileKeys = {};
    /**
     * @type {number}
     */

    _this.wantedResolution;
    /**
     * @type {!function():Array<import("./VectorTile.js").default>}
     */

    _this.getSourceTiles = getSourceTiles.bind(undefined, _this);
    /**
     * @type {import("./tilecoord.js").TileCoord}
     */

    _this.wrappedTileCoord = urlTileCoord;
    return _this;
  }
  /**
   * @param {import("./layer/Layer.js").default} layer Layer.
   * @return {CanvasRenderingContext2D} The rendering context.
   */


  VectorRenderTile.prototype.getContext = function (layer) {
    var key = (0, _util.getUid)(layer);

    if (!(key in this.context_)) {
      this.context_[key] = (0, _dom.createCanvasContext2D)(1, 1, canvasPool);
    }

    return this.context_[key];
  };
  /**
   * @param {import("./layer/Layer.js").default} layer Layer.
   * @return {boolean} Tile has a rendering context for the given layer.
   */


  VectorRenderTile.prototype.hasContext = function (layer) {
    return (0, _util.getUid)(layer) in this.context_;
  };
  /**
   * Get the Canvas for this tile.
   * @param {import("./layer/Layer.js").default} layer Layer.
   * @return {HTMLCanvasElement} Canvas.
   */


  VectorRenderTile.prototype.getImage = function (layer) {
    return this.hasContext(layer) ? this.getContext(layer).canvas : null;
  };
  /**
   * @param {import("./layer/Layer.js").default} layer Layer.
   * @return {ReplayState} The replay state.
   */


  VectorRenderTile.prototype.getReplayState = function (layer) {
    var key = (0, _util.getUid)(layer);

    if (!(key in this.replayState_)) {
      this.replayState_[key] = {
        dirty: false,
        renderedRenderOrder: null,
        renderedResolution: NaN,
        renderedRevision: -1,
        renderedTileResolution: NaN,
        renderedTileRevision: -1,
        renderedTileZ: -1
      };
    }

    return this.replayState_[key];
  };
  /**
   * Load the tile.
   */


  VectorRenderTile.prototype.load = function () {
    this.getSourceTiles();
  };
  /**
   * Remove from the cache due to expiry
   */


  VectorRenderTile.prototype.release = function () {
    for (var key in this.context_) {
      canvasPool.push(this.context_[key].canvas);
      delete this.context_[key];
    }

    _super.prototype.release.call(this);
  };

  return VectorRenderTile;
}(_Tile["default"]);

var _default = VectorRenderTile;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBTEE7Ozs7O0FBT0E7Ozs7Ozs7Ozs7O0FBV0E7OztBQUdBLElBQU1BLFVBQVUsR0FBRyxFQUFuQjs7QUFFQTtBQUFBO0FBQUE7RUFBK0JDO0VBQzdCOzs7Ozs7Ozs7RUFPQSwwQkFBWUMsU0FBWixFQUF1QkMsS0FBdkIsRUFBOEJDLFlBQTlCLEVBQTRDQyxjQUE1QyxFQUEwRDtJQUExRCxZQUNFQyxrQkFBTUosU0FBTixFQUFpQkMsS0FBakIsRUFBd0I7TUFBQ0ksVUFBVSxFQUFFO0lBQWIsQ0FBeEIsS0FBd0MsSUFEMUM7SUFHRTs7Ozs7O0lBSUFDLEtBQUksQ0FBQ0MsUUFBTCxHQUFnQixFQUFoQjtJQUVBOzs7OztJQUlBRCxLQUFJLENBQUNFLGNBQUwsR0FBc0IsRUFBdEI7SUFFQTs7Ozs7SUFJQUYsS0FBSSxDQUFDRyx1QkFBTCxHQUErQixFQUEvQjtJQUVBOzs7OztJQUlBSCxLQUFJLENBQUNJLGtCQUFMLEdBQTBCLENBQTFCO0lBRUE7Ozs7SUFHQUosS0FBSSxDQUFDSyxxQkFBTCxHQUE2QixFQUE3QjtJQUVBOzs7OztJQUlBTCxLQUFJLENBQUNNLFlBQUwsR0FBb0IsRUFBcEI7SUFFQTs7OztJQUdBTixLQUFJLENBQUNPLFdBQUwsR0FBbUIsRUFBbkI7SUFFQTs7OztJQUdBUCxLQUFJLENBQUNRLGFBQUwsR0FBcUIsRUFBckI7SUFFQTs7OztJQUdBUixLQUFJLENBQUNTLGdCQUFMO0lBRUE7Ozs7SUFHQVQsS0FBSSxDQUFDSCxjQUFMLEdBQXNCQSxjQUFjLENBQUNhLElBQWYsQ0FBb0JDLFNBQXBCLEVBQStCWCxLQUEvQixDQUF0QjtJQUVBOzs7O0lBR0FBLEtBQUksQ0FBQ1ksZ0JBQUwsR0FBd0JoQixZQUF4Qjs7RUFDRDtFQUVEOzs7Ozs7RUFJQWlCLGtEQUFXQyxLQUFYLEVBQWdCO0lBQ2QsSUFBTUMsR0FBRyxHQUFHLGtCQUFPRCxLQUFQLENBQVo7O0lBQ0EsSUFBSSxFQUFFQyxHQUFHLElBQUksS0FBS2QsUUFBZCxDQUFKLEVBQTZCO01BQzNCLEtBQUtBLFFBQUwsQ0FBY2MsR0FBZCxJQUFxQixnQ0FBc0IsQ0FBdEIsRUFBeUIsQ0FBekIsRUFBNEJ2QixVQUE1QixDQUFyQjtJQUNEOztJQUNELE9BQU8sS0FBS1MsUUFBTCxDQUFjYyxHQUFkLENBQVA7RUFDRCxDQU5EO0VBUUE7Ozs7OztFQUlBRixrREFBV0MsS0FBWCxFQUFnQjtJQUNkLE9BQU8sa0JBQU9BLEtBQVAsS0FBaUIsS0FBS2IsUUFBN0I7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7RUFLQVksZ0RBQVNDLEtBQVQsRUFBYztJQUNaLE9BQU8sS0FBS0UsVUFBTCxDQUFnQkYsS0FBaEIsSUFBeUIsS0FBS0csVUFBTCxDQUFnQkgsS0FBaEIsRUFBdUJJLE1BQWhELEdBQXlELElBQWhFO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7RUFJQUwsc0RBQWVDLEtBQWYsRUFBb0I7SUFDbEIsSUFBTUMsR0FBRyxHQUFHLGtCQUFPRCxLQUFQLENBQVo7O0lBQ0EsSUFBSSxFQUFFQyxHQUFHLElBQUksS0FBS1QsWUFBZCxDQUFKLEVBQWlDO01BQy9CLEtBQUtBLFlBQUwsQ0FBa0JTLEdBQWxCLElBQXlCO1FBQ3ZCSSxLQUFLLEVBQUUsS0FEZ0I7UUFFdkJDLG1CQUFtQixFQUFFLElBRkU7UUFHdkJDLGtCQUFrQixFQUFFQyxHQUhHO1FBSXZCQyxnQkFBZ0IsRUFBRSxDQUFDLENBSkk7UUFLdkJDLHNCQUFzQixFQUFFRixHQUxEO1FBTXZCRyxvQkFBb0IsRUFBRSxDQUFDLENBTkE7UUFPdkJDLGFBQWEsRUFBRSxDQUFDO01BUE8sQ0FBekI7SUFTRDs7SUFDRCxPQUFPLEtBQUtwQixZQUFMLENBQWtCUyxHQUFsQixDQUFQO0VBQ0QsQ0FkRDtFQWdCQTs7Ozs7RUFHQUY7SUFDRSxLQUFLaEIsY0FBTDtFQUNELENBRkQ7RUFJQTs7Ozs7RUFHQWdCO0lBQ0UsS0FBSyxJQUFNRSxHQUFYLElBQWtCLEtBQUtkLFFBQXZCLEVBQWlDO01BQy9CVCxVQUFVLENBQUNtQyxJQUFYLENBQWdCLEtBQUsxQixRQUFMLENBQWNjLEdBQWQsRUFBbUJHLE1BQW5DO01BQ0EsT0FBTyxLQUFLakIsUUFBTCxDQUFjYyxHQUFkLENBQVA7SUFDRDs7SUFDRGpCLGlCQUFNOEIsT0FBTixDQUFhQyxJQUFiLENBQWEsSUFBYjtFQUNELENBTkQ7O0VBT0Y7QUFBQyxDQTFJRCxDQUErQkMsZ0JBQS9COztlQTRJZWpCLGdCIiwibmFtZXMiOlsiY2FudmFzUG9vbCIsIl9fZXh0ZW5kcyIsInRpbGVDb29yZCIsInN0YXRlIiwidXJsVGlsZUNvb3JkIiwiZ2V0U291cmNlVGlsZXMiLCJfc3VwZXIiLCJ0cmFuc2l0aW9uIiwiX3RoaXMiLCJjb250ZXh0XyIsImV4ZWN1dG9yR3JvdXBzIiwiZGVjbHV0dGVyRXhlY3V0b3JHcm91cHMiLCJsb2FkaW5nU291cmNlVGlsZXMiLCJoaXREZXRlY3Rpb25JbWFnZURhdGEiLCJyZXBsYXlTdGF0ZV8iLCJzb3VyY2VUaWxlcyIsImVycm9yVGlsZUtleXMiLCJ3YW50ZWRSZXNvbHV0aW9uIiwiYmluZCIsInVuZGVmaW5lZCIsIndyYXBwZWRUaWxlQ29vcmQiLCJWZWN0b3JSZW5kZXJUaWxlIiwibGF5ZXIiLCJrZXkiLCJoYXNDb250ZXh0IiwiZ2V0Q29udGV4dCIsImNhbnZhcyIsImRpcnR5IiwicmVuZGVyZWRSZW5kZXJPcmRlciIsInJlbmRlcmVkUmVzb2x1dGlvbiIsIk5hTiIsInJlbmRlcmVkUmV2aXNpb24iLCJyZW5kZXJlZFRpbGVSZXNvbHV0aW9uIiwicmVuZGVyZWRUaWxlUmV2aXNpb24iLCJyZW5kZXJlZFRpbGVaIiwicHVzaCIsInJlbGVhc2UiLCJjYWxsIiwiVGlsZSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvVmVjdG9yUmVuZGVyVGlsZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==